export enum EFeedbackAction {
  SHOW_SPECTRUM = 'SHOW_SPECTRUM',
  SHOW_USER_VALUE = 'SHOW_USER_VALUE',
  SHOW_LOWER_VALUE = 'SHOW_LOWER_VALUE',
  SHOW_HIGHER_VALUE = 'SHOW_HIGHER_VALUE',
  NO_ACTION = 'NO_ACTION',
}
